import { render, staticRenderFns } from "./room-rate.vue?vue&type=template&id=272a637c&scoped=true&"
import script from "./room-rate.vue?vue&type=script&lang=js&"
export * from "./room-rate.vue?vue&type=script&lang=js&"
import style0 from "./room-rate.vue?vue&type=style&index=0&id=272a637c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "272a637c",
  null
  
)

export default component.exports